import React from 'react';
import Card from '../../ui/Card';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ZAxis, Legend, Cell } from 'recharts';
const EfficiencyMarginCorrelation: React.FC = () => {
  const data = [{
    plant: 'Manesar',
    efficiency: 94.2,
    margin: 19.5,
    revenue: 2405,
    color: '#3b82f6'
  }, {
    plant: 'Chennai',
    efficiency: 93.8,
    margin: 18.8,
    revenue: 2775,
    color: '#10b981'
  }, {
    plant: 'Pune',
    efficiency: 91.5,
    margin: 17.9,
    revenue: 2220,
    color: '#f59e0b'
  }, {
    plant: 'Bangalore',
    efficiency: 89.2,
    margin: 17.2,
    revenue: 1850,
    color: '#ef4444'
  }, {
    plant: 'Lighting BU',
    efficiency: 88.5,
    margin: 18.5,
    revenue: 2620,
    color: '#8b5cf6'
  }, {
    plant: 'Electrical BU',
    efficiency: 92.3,
    margin: 19.2,
    revenue: 3185,
    color: '#ec4899'
  }, {
    plant: 'Polymer BU',
    efficiency: 87.8,
    margin: 15.8,
    revenue: 2075,
    color: '#14b8a6'
  }, {
    plant: 'Safety BU',
    efficiency: 90.1,
    margin: 17.9,
    revenue: 1370,
    color: '#f97316'
  }];
  return <Card className="p-6 bg-gradient-to-br from-blue-50 to-white" data-id="element-2799">
      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2800">
        Efficiency vs Margin Correlation
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-2801">
        Plant & BU performance analysis (bubble size = revenue)
      </p>
      <ResponsiveContainer width="100%" height={400} data-id="element-2802">
        <ScatterChart margin={{
        top: 20,
        right: 20,
        bottom: 20,
        left: 20
      }} data-id="element-2803">
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-2804" />
          <XAxis type="number" dataKey="efficiency" name="Efficiency %" domain={[85, 95]} tick={{
          fontSize: 12
        }} label={{
          value: 'Operational Efficiency (%)',
          position: 'insideBottom',
          offset: -10,
          fontSize: 12
        }} data-id="element-2805" />
          <YAxis type="number" dataKey="margin" name="Margin %" domain={[15, 20]} tick={{
          fontSize: 12
        }} label={{
          value: 'EBITDA Margin (%)',
          angle: -90,
          position: 'insideLeft',
          fontSize: 12
        }} data-id="element-2806" />
          <ZAxis type="number" dataKey="revenue" range={[100, 1000]} name="Revenue" data-id="element-2807" />
          <Tooltip cursor={{
          strokeDasharray: '3 3'
        }} contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number, name: string) => {
          if (name === 'Revenue') return `₹${value} Cr`;
          return `${value.toFixed(1)}%`;
        }} data-id="element-2808" />
          <Legend data-id="element-2809" />
          <Scatter name="Plants & Business Units" data={data} data-id="element-2810">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-2811" />)}
          </Scatter>
        </ScatterChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-2812">
        <div className="grid grid-cols-2 gap-4" data-id="element-2813">
          {data.slice(0, 4).map((item, index) => <div key={index} className="flex items-center text-xs" data-id="element-2814">
              <div className="w-3 h-3 rounded-full mr-2" style={{
            backgroundColor: item.color
          }} data-id="element-2815" />
              <span className="text-gray-700 font-medium" data-id="element-2816">{item.plant}</span>
              <span className="ml-auto text-gray-600" data-id="element-2817">
                {item.efficiency.toFixed(1)}% / {item.margin.toFixed(1)}%
              </span>
            </div>)}
        </div>
      </div>
    </Card>;
};
export default EfficiencyMarginCorrelation;